import {NgIf} from '@angular/common';
import {Component} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NbButtonModule, NbIconModule} from '@nebular/theme';
import {FormlyModule} from '@ngx-formly/core';
import {TuiLabel, TuiTextfield, TuiTextfieldComponent, TuiTextfieldOptionsDirective} from '@taiga-ui/core';
import {TuiCalendarRange, TuiInputDateRangeDirective} from '@taiga-ui/kit';
import {BaseFieldType} from 'compob2b-libs';

@Component({
  templateUrl: './datepicker-range.component.html',
  imports: [
    FormsModule,
    FormlyModule,
    ReactiveFormsModule,
    TuiCalendarRange,
    TuiInputDateRangeDirective,
    TuiLabel,
    TuiTextfieldComponent,
    TuiTextfieldOptionsDirective,
    TuiTextfield,
    NgIf,
    NbButtonModule,
    NbIconModule,
  ]
})
export class DatepickerRangeComponent extends BaseFieldType {
}
